module.exports = __webpack_public_path__ + "static/media/roma-1.bf68ef9a.jpg";